const header = document.querySelector('header');
const nav = header.querySelector('nav');

export const changeHeaderBackgroundTo = (color, sectionBackgroundColor) => {
  switch (color) {
    case 'white':
      header.style.backgroundColor = '#FFFFFF';
      header.style.boxShadow = '0px 3px 6px 0px #1D1D1B0F';
      nav.style.backgroundColor = '#FFFFFF';
      nav.style.borderBottom = '1px solid transparent';
      nav.classList.remove('white-content');
      break;
    case 'black':
      header.style.backgroundColor = sectionBackgroundColor;
      header.style.boxShadow = '';
      nav.style.backgroundColor = sectionBackgroundColor;
      nav.style.borderBottom = '';
      nav.classList.add('white-content');
      break;
    case 'dark':
      header.style.backgroundColor = sectionBackgroundColor;
      header.style.boxShadow = '';
      nav.style.backgroundColor = sectionBackgroundColor;
      nav.style.borderBottom = '1px solid #383836';
      nav.classList.add('white-content');
      break;
    case 'otherColor':
      header.style.backgroundColor = sectionBackgroundColor;
      header.style.boxShadow = '';
      nav.style.backgroundColor = sectionBackgroundColor;
      nav.style.borderBottom = '';
      nav.classList.remove('white-content');
  }
};
